// extracted by mini-css-extract-plugin
export default {"services-page":"aMbSv36rs4Zc86_WLcCo","top-pane":"SxbylZrGR4ABuGqGXJC_","title-txt":"YzwHtIBwutyN1U2QO4um","center-pane":"FlYY9gkDAGVy34Ggjl4E"};